import { render, staticRenderFns } from "./BaseVSelectComplexMulti.vue?vue&type=template&id=e5e74922"
import script from "./BaseVSelectComplexMulti.vue?vue&type=script&lang=js"
export * from "./BaseVSelectComplexMulti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports